<template>
    <div class="announcement bg-primary text-white">
        <p class="text-white">{{ text }}</p>
    </div> 
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: true,
        }
    },
};
</script>

<style>
.announcement {
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 9999;
    padding: .5em 0;
    margin: 0;
    text-align: center;
}

.announcement p {
    padding: 0;
    margin: 0;
}
</style>